import {Action} from 'redux'
import {ProductSubCategoryModel} from '../Model/ProductSubCategoryModel'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialProductSubCategoryState: IProductSubCategoryState = {
  data: {
    productSubCategory: [],
    meta: [],
  },
  sortProductSubCategoryData: [],
  productSubCategoryList: {productSubCategory: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface IProductSubCategoryState {
  data?: {
    productSubCategory?: ProductSubCategoryModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortProductSubCategoryData?: IProductSubCategoryState[]
  productSubCategoryList?: {productSubCategory: ProductSubCategoryModel[]}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IProductSubCategoryState = initialProductSubCategoryState,
  action: ActionWithPayload<IProductSubCategoryState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_PRODUCT_SUB_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_PRODUCT_SUB_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        productCategoryList: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_PRODUCT_SUB_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET ProductSubCategory DATA
    case actionTypes.GET_PRODUCT_SUB_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_PRODUCT_SUB_CATEGORY_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_PRODUCT_SUB_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add ProductSubCategory
    case actionTypes.ADD_PRODUCT_SUB_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_PRODUCT_SUB_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_PRODUCT_SUB_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_PRODUCT_SUB_CATEGORY: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update ProductSubCategory
    case actionTypes.UPDATE_PRODUCT_SUB_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_PRODUCT_SUB_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_PRODUCT_SUB_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_PRODUCT_SUB_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_PRODUCT_SUB_CATEGORY_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_PRODUCT_SUB_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_PRODUCT_SUB_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_PRODUCT_SUB_CATEGORY_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_PRODUCT_SUB_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_PRODUCT_SUB_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_PRODUCT_SUB_CATEGORY_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_PRODUCT_SUB_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_PRODUCT_SUB_CATEGORY_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_PRODUCT_SUB_CATEGORY_SUCCESS: {
      const changedData: any = action.payload?.data?.productSubCategory
      let newData = state?.data?.productSubCategory?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, productSubCategory: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_PRODUCT_SUB_CATEGORY_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_PRODUCT_SUB_CATEGORY_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_PRODUCT_SUB_CATEGORY_SUCCESS: {
      const changedData: any = action.payload?.data?.productSubCategory
      let newData = state?.data?.productSubCategory?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, productSubCategory: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_PRODUCT_SUB_CATEGORY_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_PRODUCT_SUB_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_PRODUCT_SUB_CATEGORY_SUCCESS: {
      return {
        ...state,
        sortProductSubCategoryData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_PRODUCT_SUB_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_PRODUCT_SUB_CATEGORY_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortProductSubCategoryData: [],
      }
    }

    default:
      return state
  }
}
